import { z } from 'zod'

const workflowCancelResponseSchema = z.object({
  message: z.string(),
  success: z.boolean(),
})

export { workflowCancelResponseSchema }
